export default __webpack_public_path__ + "static/media/portfolio-scmb.730f7b82.png";